// Module
var code = "<template>\n  <div class=\"form-element\">\n    <label for=\"name\" t=\"general.size\"></label>\n    <numeric-input type=\"text\" name=\"size\" value.bind=\"penPipeSize.Size\" />\n  </div>\n  <div if.bind=\"isDuplicate\" style=\"margin-bottom: 1rem\"><span class=\"warning\" t=\"pens.duplicatePipeSize\"></span></div>\n</template>\n";
// Exports
export default code;